import { persistentAtom } from "@nanostores/persistent";
import { type Address, type Hash, isAddressEqual } from "viem";
import { deserialize, serialize } from "wagmi";
import { LocalStorageKeys } from "./keys";

export type L2TokenRegParams = {
  tokenAddr: Address;
  hash: Hash;
  l2BlockNumber: number;
  index: bigint;
};

const $l2TokenRegParamsAtom = persistentAtom<L2TokenRegParams[]>(LocalStorageKeys.L2_TOKEN_REG_KEY, [], {
  encode: serialize,
  decode: deserialize,
});

export function getL2TokenReg(): L2TokenRegParams[] {
  return $l2TokenRegParamsAtom.get();
}

export function getL2TokenRegByTokenAddr(tokenAddr: Address): L2TokenRegParams | undefined {
  const reg = $l2TokenRegParamsAtom.get();
  return reg.find((r) => isAddressEqual(r.tokenAddr, tokenAddr));
}

export function storeL2TokenReg(reg: L2TokenRegParams) {
  const history = $l2TokenRegParamsAtom.get();
  const data = history.concat(reg);
  $l2TokenRegParamsAtom.set(data);
}
